// extracted by mini-css-extract-plugin
export default {"card":"ResourceConflictCard_card__wBPLM","title":"ResourceConflictCard_title__WJg+k","scopeTag":"ResourceConflictCard_scopeTag__iUY19","detail":"ResourceConflictCard_detail__IE7Qy"};